import(/* webpackMode: "eager" */ "/vercel/path0/src/app/sign-up/[[...sign-up]]/page.tsx");
